import { IconProps } from './IconProps';

export const UHRingFill = (props: IconProps) => {
  return (
    <svg
      className={props.className}
      style={props.style}
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_859_313)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M7.99984 0.666626C12.0499 0.666626 15.3332 3.94987 15.3332 7.99996C15.3332 12.05 12.0499 15.3333 7.99984 15.3333C3.94975 15.3333 0.666504 12.05 0.666504 7.99996C0.666504 3.94987 3.94975 0.666626 7.99984 0.666626ZM7.99984 2.13329C4.75977 2.13329 2.13317 4.75989 2.13317 7.99996C2.13317 11.24 4.75977 13.8666 7.99984 13.8666C11.2399 13.8666 13.8665 11.24 13.8665 7.99996C13.8665 4.75989 11.2399 2.13329 7.99984 2.13329ZM11.2995 12.4006C10.3803 13.0909 9.23784 13.5 7.99984 13.5C6.76191 13.5 5.6195 13.091 4.70037 12.4008L11.2995 12.4006Z"
          fill={props.fill ?? '#000'}
        />
      </g>
      <defs>
        <clipPath id="clip0_859_313">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
